import { render, staticRenderFns } from "./chooseSendNode.vue?vue&type=template&id=1aa7a9a2&"
import script from "./chooseSendNode.vue?vue&type=script&lang=js&"
export * from "./chooseSendNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/flow/chooseSendNode.vue"
export default component.exports